var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-container"},[_c('div',{staticClass:"emoji-oops"},[_vm._v("\n\t\t🤔\n\t")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"tp-link",attrs:{"to":"/home"}},[_vm._v("Go to home page")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('p',[_vm._v("Oops, page not found.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34557fda","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = null
// module chunks = 